export enum TypesLabel {
    SENT = 'sent',
    COLLECTION = 'collection',
    READY = 'ready',
    RECEIVED = 'received',
    CANCELLED = 'cancelled'
}
